(function () {
  function initSet(root) {
    if (root.dataset.init) return;
    root.dataset.init = 'true';
    const q = (selector) => root.querySelector(selector);
    const qa = (selector) => [...root.querySelectorAll(selector)];
    const money = (cents) => window.BB?.money ? window.BB.money(cents) : '$' + (cents / 100).toFixed(2);
    const nameInput = q('[data-name]');
    const preview = q('[data-preview]');
    const error = q('[data-err]');
    const mainButton = q('[data-atc]');
    const stickyButton = q('[data-sticky-btn]');
    const quote = q('[data-wa-btn]');
    if (!q('[data-tier]:checked') && q('[data-tier]')) q('[data-tier]').checked = true;
    const tier = () => q('[data-tier]:checked');
    const metal = () => q('[data-mat]:checked');
    const goldSelected = () => metal().hasAttribute('data-gold');
    const needsName = () => tier().dataset.nameNeeded === 'true';
    const giftFor = (offer) => {
      const box = offer.closest('.rset__tier').querySelector('[data-gift]');
      return box && box.checked ? box : null;
    };
    const sample = preview.textContent;
    let adding = false;

    function paint() {
      const offer = tier();
      const gold = goldSelected();
      const unavailable = offer.hasAttribute('data-sold-out');
      const gift = giftFor(offer);
      const total = Number(offer.dataset.total) + (gift ? Number(gift.dataset.giftPrice) : 0);
      qa('[data-tier]').forEach((option) => option.closest('.rset__tier').classList.toggle('is-on', option.checked));
      qa('[data-gift]').forEach((box) => box.closest('.rset__gift').classList.toggle('is-on', box.checked));
      qa('[data-mat]').forEach((option) => option.closest('.rset__mat').classList.toggle('is-on', option.checked));
      qa('[data-total]').forEach((price) => { price.innerHTML = money(total); price.hidden = gold; });
      qa('[data-tp]').forEach((price) => { price.style.visibility = gold ? 'hidden' : ''; });
      qa('[data-gold-only]').forEach((price) => { price.hidden = !gold; });
      const compare = q('[data-compare]');
      if (compare) {
        if (!compare.dataset.orig) compare.dataset.orig = compare.innerHTML;
        const value = Number(offer.dataset.value || 0);
        const isSingle = offer.dataset.pieces.indexOf(',') === -1;
        if (value > Number(offer.dataset.total)) { compare.innerHTML = money(value + (gift ? Number(gift.dataset.giftPrice) : 0)); compare.hidden = gold; }
        else if (isSingle) { compare.innerHTML = compare.dataset.orig; compare.hidden = gold; }
        else compare.hidden = true;
      }
      root.classList.toggle('is-gold', gold);
      q('[data-name-step]').hidden = !needsName();
      q('[data-tier-number]').textContent = needsName() ? '3' : '2';
      mainButton.hidden = gold;
      mainButton.disabled = adding || unavailable;
      q('[data-atc-label]').textContent = unavailable ? 'Sold out' : 'Add to Cart';
      stickyButton.disabled = adding || (!gold && unavailable) || (gold && !quote);
      if (quote) {
        quote.textContent = gold ? quote.dataset.waGold : quote.dataset.waNormal;
        quote.classList.toggle('rset__wa--main', gold);
        const name = nameInput.value.trim();
        const url = new URL(location.href);
        url.search = '';
        url.hash = '';
        const lines = ['Hi Rasmati! I want: ' + root.dataset.title, 'Material: ' + metal().value, 'Option: ' + offer.dataset.label];
        if (gift) lines.push('+ Gift box');
        if (name && needsName()) lines.push('Name: ' + name);
        if (gold) lines.push('Please send me the real gold price.');
        lines.push(url.href);
        quote.href = 'https://wa.me/' + root.dataset.wanum + '?text=' + encodeURIComponent(lines.join('\n'));
      }
      stickyButton.textContent = gold ? (quote?.dataset.waGold || 'Request a quote') : (unavailable ? 'Sold out' : 'Add to Cart');
    }

    nameInput.addEventListener('input', () => {
      preview.textContent = nameInput.value.trim() || sample;
      preview.lang = /[؀-ۿ]/.test(preview.textContent) ? 'ar' : 'en';
      nameInput.classList.remove('is-bad');
      error.hidden = true;
      paint();
    });
    root.addEventListener('change', paint);

    async function add(button) {
      if (goldSelected()) {
        if (quote) window.open(quote.href, '_blank', 'noopener');
        return;
      }
      const offer = tier();
      if (adding || offer.hasAttribute('data-sold-out')) return;
      const name = needsName() ? nameInput.value.trim() : '';
      if (needsName() && !name) {
        error.hidden = false;
        nameInput.classList.add('is-bad');
        nameInput.focus();
        return;
      }
      const ids = offer.dataset.items.split(',').map(Number);
      const pieces = offer.dataset.pieces.split(',');
      const includedBox = pieces.length > 1;
      const gift = giftFor(offer);
      const items = ids.map((id, index) => {
        const properties = { Material: metal().value, '_Rasmati month': root.dataset.month };
        const itemPieces = pieces.slice(index, index === ids.length - 1 ? undefined : index + 1);
        properties['_Rasmati pieces'] = itemPieces.join(',');
        if (name && itemPieces.some((piece) => piece !== 'earrings')) properties.Name = name;
        if (index === 0) {
          properties.Birthstone = root.dataset.stone + ' (free)';
          if (includedBox) {
            properties['Gift box'] = 'Included';
            properties['_Rasmati box'] = 'included';
          } else if (gift) {
            properties['Gift box'] = 'Added';
          }
        } else if (name) properties.For = root.dataset.title + ' — ' + name;
        return { id, quantity: 1, properties };
      });
      if (gift) items.push({ id: Number(gift.dataset.giftId), quantity: 1, properties: { For: root.dataset.title + (name ? ' — ' + name : '') } });
      adding = true;
      mainButton.disabled = true;
      stickyButton.disabled = true;
      try {
        await window.BB.cart.add(items, { button, source: 'rset', flash: false, open: true });
      } catch {
        // The shared Shopify cart displays its own error.
      } finally {
        adding = false;
        paint();
      }
    }

    mainButton.addEventListener('click', () => add(mainButton));
    stickyButton.addEventListener('click', () => add(stickyButton));

    const dialog = q('[data-zoombox]');
    const image = q('[data-zoom-img]');
    const caption = q('[data-zoom-caption]');
    qa('[data-preview-piece]').forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      image.src = button.dataset.image;
      image.alt = button.dataset.caption;
      caption.textContent = button.dataset.caption;
      dialog.showModal();
    }));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const track = q('[data-track]');
    const dots = qa('.rset__dots i');
    if (track && dots.length) track.addEventListener('scroll', () => {
      const active = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, index) => dot.classList.toggle('is-on', index === active));
    }, { passive: true });

    const sticky = q('[data-sticky]');
    if ('IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-up', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(q('.rset__atc'));
    }
    paint();
  }

  document.querySelectorAll('[data-rset]').forEach(initSet);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-rset]').forEach(initSet));
})();
